import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { sizes } from "@sonder/ui/source/styled/theme";

const StyledContentLoader = styled(ContentLoader)`
  box-sizing: border-box;
  height: 300px;
  margin: 0 auto;
  max-width: ${sizes.listWidth};
  padding: 1.5rem 1.714rem 0 1.714rem;
  width: 100%;
`;

export const ReportsViewContentLoader = () => (
  <StyledContentLoader height={300} width={126}>
    <rect fill="#000" height="13" width="126" x="-2" y="13" />
    <rect fill="#000" height="13" width="126" x="-2" y="60" />
    <rect fill="#000" height="13" width="126" x="-2" y="104" />
  </StyledContentLoader>
);
